module.exports = __webpack_public_path__ + "img/partners.8228ade3.jpg";